/* eslint-disable no-template-curly-in-string */
// @flow

export default {
  NoRecordsFound: '記録が見つかりませんでした。',
  DocumentIndex: '文書インデックス',
  SubmissionIndex: '提出インデックス',
  Search: '検索',
  Searching: '検索中...',
  Filter: 'フィルター',
  FullTextSearch_SentenceCase: '全文検索',
  BulkDownload_SentenceCase: '一括ダウンロード',
  ExportToExcel: 'Excel にエクスポート',
  ExpandAll_SentenceCase: 'すべて展開',
  CollapseAll_SentenceCase: 'すべて折りたたむ',
  BulkDownloadName_SentenceCase: 'パッケージ名',
  SelectAll_SentenceCase: 'すべて選択',
  AskQuestion: '質問する',
  Move: '動く',
  Edit: '編集',
  OpenInOfficeOnline: 'Web 用 Microsoft Office で開く',
  EditInOfficeOnline: 'Web 用 Microsoft Office で編集する',
  Security: '安全',
  Enable: '有効にする',
  Disable: '無効にする',
  Delete: '消去',
  History: '歴史',
  History_LowerCase: '歴史',
  ManageDocuments: '文書の管理',
  SelectDocumentsToRedact: '編集するドキュメントを選択してください',
  Submissions: '提出物',
  TenderSubmissions: '入札提出',
  Add: '追加',
  Folder: 'フォルダ',
  Document: '書類',
  Document_LowerCase: '書類',
  Documents_LowerCase: '書類',
  Folder_LowerCase: 'フォルダ',
  Folders_LowerCase: 'フォルダ',
  Renumber: '番号を付け直す',
  BulkUpload_SentenceCase: '一括アップロード',
  BulkDownloadOverDownloadLimit:
    'ダウンロード サイズ制限の 100 GB に達しました。続行するには、選択からファイルを削除してください。',
  Name_: '名前：',
  Number_: '番号：',
  Retry: 'リトライ',
  FolderNotDeletedAccess:
    'エラー: フォルダーには、アクセスが許可されていない 1 つ以上のドキュメントやサブフォルダーが含まれているため、削除できませんでした。',
  FolderNotDeleted: 'エラー: フォルダーを削除できませんでした。',
  DocumentNotDeleted: 'エラー: ドキュメントを削除できませんでした。',
  FolderNotUpdated: 'エラー: フォルダーを更新できませんでした。',
  DocumentNotUpdated: 'エラー: ドキュメントを更新できませんでした。',
  ParentFolderDisabled: '親フォルダーが無効になっています',
  EnableDocument:
    'このフォルダには 1 つのドキュメントが含まれています。このフォルダを有効にしてもよろしいですか?',
  EnableDocuments: '\u003cb\u003eドキュメントを有効にする\u003c/b\u003e',
  EnableFolder:
    'このフォルダには 1 つのフォルダが含まれています。このフォルダを有効にしてもよろしいですか?',
  EnableFolderDocument:
    'このフォルダには 1 つのフォルダと 1 つのドキュメントが含まれています。このフォルダを有効にしてもよろしいですか?',
  EnableFolderDocuments:
    'このフォルダーには 1 つのフォルダーと ${NumberOfDocuments} ドキュメントが含まれています。このフォルダーを有効にしてもよろしいですか?',
  EnableFolders:
    'このフォルダーには ${NumberOfFolders} フォルダーが含まれています。このフォルダーを有効にしてもよろしいですか?',
  EnableFoldersDocument:
    'このフォルダーには ${NumberOfFolders} フォルダーと 1 つのドキュメントが含まれています。このフォルダーを有効にしてもよろしいですか?',
  EnableFoldersDocuments:
    'このフォルダーには ${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントが含まれています。このフォルダーを有効にしてもよろしいですか?',
  BulkEnableFolders: '${NumberOfFolders} フォルダーが有効になります。',
  BulkEnableFoldersWithImplicitFolders:
    'これらの項目を有効にするには、すべての親フォルダーを有効にする必要があります。 ${NumberOfFolders} フォルダーが有効になります。',
  BulkEnableOneFolder: '1 つのフォルダーが有効になります。',
  BulkEnableOneFolderAndDocuments:
    '1 つのフォルダーと ${NumberOfDocuments} ドキュメントが有効になります。',
  BulkEnableOneFolderAndDocumentsWithImplicitFolders:
    'これらの項目を有効にするには、すべての親フォルダーを有効にする必要があります。 1 つのフォルダーと ${NumberOfDocuments} ドキュメントが有効になります。',
  BulkEnableOneFolderAndOneDocument:
    '1 つのフォルダーと 1 つのドキュメントが有効になります。',
  BulkEnableOneFolderAndOneDocumentWithImplicitFolders:
    'これらの項目を有効にするには、すべての親フォルダーを有効にする必要があります。 1 つのフォルダーと 1 つのドキュメントが有効になります。',
  BulkEnableDocuments: '${NumberOfDocuments} ドキュメントが有効になります。',
  BulkEnableOneDocument: '1 つのドキュメントが有効になります。',
  BulkEnableFoldersAndOneDocument:
    '${NumberOfFolders} フォルダーと 1 つのドキュメントが有効になります。',
  BulkEnableFoldersAndOneDocumentWithImplicitFolders:
    'これらの項目を有効にするには、すべての親フォルダーを有効にする必要があります。 ${NumberOfFolders} フォルダーと 1 つのドキュメントが有効になります。',
  BulkEnableFoldersAndDocuments:
    '${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントが有効になります。',
  BulkEnableFoldersAndDocumentsWithImplicitFolders:
    'これらの項目を有効にするには、すべての親フォルダーを有効にする必要があります。 ${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントが有効になります。',
  BulkEnableDocumentsErrorMessage:
    'エラー: ${NumberOfDocuments} ドキュメントを有効にできませんでした。',
  BulkEnableFoldersErrorMessage:
    'エラー: ${NumberOfFolders} フォルダーを有効にできませんでした。',
  BulkEnableFoldersDocumentsErrorMessage:
    'エラー: ${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントを有効にできませんでした。',
  DisableDocument:
    'このフォルダには 1 つのドキュメントが含まれています。このフォルダを無効にしてもよろしいですか?',
  DisableDocuments: '\u003cb\u003eドキュメントを無効にする\u003c/b\u003e',
  DisableFolder:
    'このフォルダには 1 つのフォルダが含まれています。このフォルダを無効にしてもよろしいですか?',
  DisableFolderDocument:
    'このフォルダには 1 つのフォルダと 1 つのドキュメントが含まれています。このフォルダを無効にしてもよろしいですか?',
  DisableFolderDocuments:
    'このフォルダーには 1 つのフォルダーと ${NumberOfDocuments} ドキュメントが含まれています。このフォルダーを無効にしてもよろしいですか?',
  DisableFolders:
    'このフォルダーには ${NumberOfFolders} フォルダーが含まれています。このフォルダーを無効にしてもよろしいですか?',
  DisableFoldersDocument:
    'このフォルダーには ${NumberOfFolders} フォルダーと 1 つのドキュメントが含まれています。このフォルダーを無効にしてもよろしいですか?',
  DisableFoldersDocuments:
    'このフォルダーには ${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントが含まれています。このフォルダーを無効にしてもよろしいですか?',
  DisableFolderConfirm:
    '「${FolderName}」フォルダー内には他のフォルダーが含まれており、それらも無効になります。',
  BulkDisableFolders: '${NumberOfFolders} フォルダーは無効になります。',
  BulkDisableOneFolder: '1 つのフォルダーが無効になります。',
  BulkDisableOneFolderAndDocuments:
    '1 つのフォルダーと ${NumberOfDocuments} ドキュメントが無効になります。',
  BulkDisableOneFolderAndOneDocument:
    '1 つのフォルダーと 1 つのドキュメントが無効になります。',
  BulkDisableDocuments: '${NumberOfDocuments} ドキュメントは無効になります。',
  BulkDisableOneDocument: '1 つのドキュメントが無効になります。',
  BulkDisableFoldersAndOneDocument:
    '${NumberOfFolders} フォルダーと 1 つのドキュメントが無効になります。',
  BulkDisableFoldersAndDocuments:
    '${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントは無効になります。',
  BulkDisableDocumentsErrorMessage:
    'エラー: ${NumberOfDocuments} ドキュメントを無効にできませんでした。',
  BulkDisableFoldersErrorMessage:
    'エラー: ${NumberOfFolders} フォルダーを無効にできませんでした。',
  BulkDisableFoldersDocumentsErrorMessage:
    'エラー: ${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントを無効にできませんでした。',
  DeleteFileConfirmation: '「${FileName}」はすぐに削除されます。',
  DeleteFolderConfirmation: '「${FolderName}」はすぐに削除されます。',
  BulkDeleteFolders: '${NumberOfFolders} フォルダーが削除されます。',
  BulkDeleteOneFolder: '1 個のフォルダーが削除されます。',
  BulkDeleteOneFolderAndDocuments:
    '1 つのフォルダーと ${NumberOfDocuments} ドキュメントが削除されます。',
  BulkDeleteOneFolderAndOneDocument:
    '1 つのフォルダーと 1 つのドキュメントが削除されます。',
  BulkDeleteDocuments: '${NumberOfDocuments} ドキュメントは削除されます。',
  BulkDeleteOneDocument: '1 件の文書が削除されます。',
  BulkDeleteFoldersAndOneDocument:
    '${NumberOfFolders} フォルダーと 1 つのドキュメントが削除されます。',
  BulkDeleteFoldersAndDocuments:
    '${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントが削除されます。',
  BulkDeleteDocumentsErrorMessage:
    'エラー: ${NumberOfDocuments} ドキュメントを削除できませんでした。',
  BulkDeleteFoldersErrorMessage:
    'エラー: ${NumberOfFolders} フォルダーを削除できませんでした。',
  BulkDeleteFoldersDocumentsErrorMessage:
    'エラー: ${NumberOfFolders} フォルダーと ${NumberOfDocuments} ドキュメントを削除できませんでした。',
  AddFolder: 'フォルダーを追加',
  AddDocument: 'ドキュメントの追加',
  CopyLink_SentenceCase: 'リンクをコピーする',
  SendToKira_SentenceCase: 'キラに送る',
  Actions: '行動',
  Download: 'ダウンロード',
  DownloadPart: 'パーツをダウンロード ${number}',
  BulkDownloadIsNotSwitchedOnContactAdmin_Gen2:
    '一括ダウンロードがオンになっていません。詳細については管理者にお問い合わせください',
  Disabled: '無効',
  FileTypeUnknown: 'ファイル',
  FileTypeAcrobat: 'アクロバットPDF',
  FileTypeArchive: 'アーカイブ',
  FileTypeAudio: '音声ファイル',
  FileTypeCode: 'コード',
  FileTypeContact: '接触',
  FileTypeEmail: 'Eメール',
  FileTypeExcel: 'エクセル',
  FileTypeImage: '画像',
  FileTypeLayoutAndDesign: '設計書',
  FileTypePowerpoint: 'パワーポイント',
  FileTypeText: '文章',
  FileTypeVideo: 'ビデオ',
  FileTypeVisio: 'ヴィジオ',
  FileTypeWord: '言葉',
  SavingAllowed: '保存可能',
  SavingDenied: '保存が拒否されました',
  PrintingAllowed: '印刷許可',
  PrintingDenied: '印刷が拒否されました',
  FileExtensionEmpty: '延長なし',
  OneBulkDownloadInProgress: '1 件の一括ダウンロードが進行中 - ${progress}%',
  NumberOfBulkDownloadInProgress:
    '${number} の一括ダウンロードが進行中 - ${progress}%',
  Cancel: 'キャンセル',
  Expand: '拡大する',
  Collapse: '崩壊',
  FolderEmpty: 'フォルダーが空です',
  UseChromeToBulkUpload:
    'Chrome を使用してドキュメントとフォルダーを一括アップロードします。',
  RenumberCallToAction: '番号を付け直す',
  Archives: 'アーカイブ',
  BulkDownloadUnavailable:
    '現在、一括ダウンロードは利用できません。後でもう一度試してください',
  PreviewNotAvailable: 'プレビューは利用できません',
  DocumentIsTooLargeToPreview:
    'このドキュメントは大きすぎてプレビューできません。閲覧するにはドキュメントをダウンロードする必要があります。',
  DocumentIsTooLargeToPreviewWithoutDownload:
    'このドキュメントは大きすぎてプレビューできません',
  FileCannotBePreviewed: 'このファイルはプレビューできません。',
  OwnerHasSecuredThisDocument: '所有者がこの文書を保護しました',
  ThisDocumentIsSecuredWithAdobeRightsManagement:
    'このドキュメントは Adobe Rights Management で保護されています。このドキュメントを表示するには、Adobe Acrobat Reader が必要で、オンラインに接続している必要があります。',
  ThisDocumentIsSecuredWithMicrosoftRightsManagement:
    'このドキュメントは Microsoft Rights Management によって保護されています。このドキュメントを表示するには、Microsoft Office とオンラインが必要です。',
  SecuredPdfHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eの表示の詳細をご覧ください。 PDF ドキュメント。\u003c/a\u003e',
  SecuredPdfHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eの表示の詳細をご覧ください。 PDF ドキュメント。\u003c/a\u003e',
  SecuredDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 クラスの詳細をご覧ください=\u0022ace-helplink\u0022\u003eOffice ドキュメントの表示。\u003c/a\u003e',
  YourDownloadIsBeingPrepared: 'ダウンロードを準備中です...',
  OwnerHasSecuredTheseDocuments: '所有者はこれらの書類を確保しました',
  SecuredPdfAndDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eの表示の詳細をご覧ください。 PDF ドキュメント\u003c/a\u003eまたは \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target =\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice ドキュメント。\u003c/a\u003e',
  SecuredPdfAndDocHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eの表示の詳細をご覧ください。 PDF ドキュメント\u003c/a\u003eまたは \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target =\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice ドキュメント。\u003c/a\u003e',
  DocumentsAreSecuredWithMicrosoftOrAdobeRightsManagement:
    'これらのドキュメントは、Adobe Rights Management または Microsoft Rights Management によって保護されています。これらのドキュメントを表示するには、Adobe Acrobat Reader または Microsoft Office が必要で、オンラインに接続している必要があります。',
  UnableToDownloadThisFileTryAgain: 'このファイルをダウンロードできません。',
  DownloadStarted: 'ダウンロード開始',
  Close: '近い',
  GotIt: 'わかった',
  Preview: 'プレビュー',
  DontShowThisAgain: 'これを二度と表示しないでください',
  BulkDownloadPrepareTitle: 'ダウンロードを準備中です...',
  BulkDownloadPrepareAwareMessage:
    'ダウンロードのサイズが大きくなるほど、処理に時間がかかる可能性があることに注意してください。',
  BulkDownloadPrepareMessage:
    'ダウンロードの準備が完了すると、 <strong>${email}</strong>に電子メールが送信されます。',
  BulkDownloadLimitError:
    '${limitedNumberOfItems} ファイルまたは ${limitedFileSize} のダウンロード制限に達しました。続行するには、選択からファイルを削除してください。',
  LinkCopiedToClipboard: 'リンクがクリップボードにコピーされました',
  RestoreDocuments: '文書を復元する',
  RepairNumbering: '修理番号付け',
  BulkUpdate: '一括更新',
  GenerateFolders: 'フォルダーの生成',
  NotificationsReport: '通知レポート',
  DownloadHelpInfo: '数秒経ってもダウンロードが開始されない場合は、',
  DirectLink: '直接リンク',
  YourDocumentsAreDownloading: '書類をダウンロード中です。',
  DocumentRenamed: 'ドキュメントの名前が変更されました。',
  FolderRenamed: 'フォルダーの名前が変更されました。',
  FolderRenamedRenumber: '番号を付け直してフォルダーの内容を更新します',
  DocumentsNotificationList: '文書通知リスト',
  UserDocumentNotificationSettings: 'ユーザー文書通知設定',
  IntervalType: 'インターバルタイプ',
  NumberOfUsers: 'ユーザー数',
  NotificationList: 'お知らせ一覧',
  ExportSelectedItemsToExcel: '[数値] を Excel にエクスポート',
  ToEmail: 'メールする',
  FromSentDateSydneyTime: '送信日から (シドニー時間)',
  ToSentDateSydneyTime: '送信日まで (シドニー時間)',
  DocID: 'ドキュメントID',
  DocName: 'ドキュメント名',
  To: 'に',
  UserType: 'ユーザータイプ',
  SentDateSydneyTime: '送信日 (シドニー時間)',
  Previous: '前の',
  Next: '次',
  DisableFolderConfirmHeader: 'フォルダーを無効にしようとしています',
  ThereAreNoAvailableFoldersAndDocumentsAtTheMoment:
    '現時点では、使用可能なドキュメントまたはフォルダーはありません。',
  ThereAreNoDocumentsOrFoldersMatchingFilterCriteria:
    'フィルター条件に一致するドキュメントまたはフォルダーはありません。',
  DeleteFolderConfirmHeader: 'フォルダーを削除しようとしています',
  DeleteFileConfirmHeader: 'ファイルを削除しようとしています',
  MoveItemDialogUseDestinationFolderSecurity:
    '${destinationFolderName} のフォルダー セキュリティ設定を使用する',
  MoveItemDialogSecuritySettingsLabel: 'セキュリティ設定',
  MoveItemDialogUseCurrentFolderSecurity: '現在のセキュリティ設定を使用する',
  MoveItemDialogNotifyCheckbox: 'アクセスが許可されたときに人々に通知する',
  MoveItemNewLocation: '新しい場所： ',
  DontHavePermissionToMoveFolder: 'このフォルダーを移動する権限がありません。',
  DontHavePermissionToMoveFolders:
    'これらのフォルダーを移動する権限がありません。',
  DontHavePermissionToMoveItemsMoveIntoFolder:
    'このフォルダーにアイテムを移動する権限がありません。',
  SecuredFileIsTooLargeToPreview:
    'プレビューしようとしているファイルが大きすぎます。代わりにダウンロードできます。',
  SecuredFileIsTooLargeToPreviewWithoutDownload:
    'プレビューしようとしているファイルが大きすぎます。',
  BeforeYouDownload: 'ダウンロードする前に',
  SecuredPreviewPdfHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003e表示の詳細PDF ドキュメント。\u003c/a\u003e',
  SecuredPreviewPdfHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003e表示の詳細PDF ドキュメント。\u003c/a\u003e',
  SecuredPreviewDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace -helplink\u0022\u003eOffice ドキュメントの表示について詳しくは、\u003c/a\u003eをご覧ください。 ',
  StartYourDataRoomAndAddDocument:
    'データ ルームを開始してドキュメントを追加します。',
  UploadDocuments: '書類のアップロード',
  ExpiredDocumentAccess:
    'このドキュメントへのアクセス期限が切れています。アクセスするには、データ ルーム管理者に連絡してください。',
  MultipleDragDropInfo:
    '移動するドキュメントとフォルダーを選択し、ドラッグ アンド ドロップします。',
  DemoMultipleDragDropTitle: '使い方',
  Zipping: 'ジップアップ',
  Processing: '処理...',
  YourFilesAreReadyToDownload: 'ファイルをダウンロードする準備ができました',
  ThisBulkDownloadIsSplit:
    'このダウンロードは大きすぎるため、複数の部分に分割しました。これらのリンクは電子メールにも記載されています。',
  BulkDownloadEmptyFoldersNote: '空のフォルダーはダウンロードされません。',
  NotifyPeopleWhenAccessIsGranted: 'アクセスが許可されたときに人々に通知する',
  BulkEnableConfirmHeader: 'フォルダーとドキュメントを有効にする',
  BulkDisableConfirmHeader: 'フォルダーとドキュメントを無効にする',
  CopyDocumentsInProgress: 'ドキュメントインデックスのロードが進行中です',
  SomeDocumentsAreSecuredLink:
    '一部のドキュメントは管理者によって保護されています。それらを開くには、次のものが必要です。',
  EnableTruncation: '切り捨てを有効にする',
  OptimizeFilePathForWindows: 'Windows 用にファイル パスを最適化する',
  TruncationNoteForWindows:
    'Windows ユーザーの場合、Windows 10 で 7-Zip を使用して解凍する必要があります。',
  Restore: '復元する',
  Current: '現在',
  AddedBy: 'によって追加',
  UpdatedBy: '更新者',
  RestoreThisVersion: 'このバージョンを復元する',
  AdobeAcrobatReader: 'Adobe Acrobat Reader',
  MicrosoftOffice: 'マイクロソフトオフィス',
  InternetConnection: 'インターネット接続',
  BulkDeleteConfirmHeader: 'フォルダーとドキュメントを削除する',
  Preparing: '準備...',
  SomeSavingDeniedFilesSelected:
    '${number} ドキュメントには「保存が拒否されました」ポリシーが設定されているため、ダウンロードされません。',
  RestoreDocumentSuccessMessage: '${title} が復元されました',
  RestoreVersionNumberButtonText: 'バージョンを復元 ${versionNumber}',
  HistoryDialogNothingChangeMessage:
    'このバージョンは現在のバージョンと同じです',
  HistoryDialogNoDocumentChangeMessage: '文書の内容は変更されていません',
  HistoryDialogNoNameAndNumberChangeMessage:
    '文書の名前と番号は変更されていません',
  ResetViewAsToDownload:
    'ダウンロードするには「表示形式」フィルターをリセットします。',
  NoPermissionToDownloadTooltip:
    '管理者はこのルームの一括ダウンロードを無効にしています',
  Remove: '取り除く',
  Reset: 'リセット',
  ResetNow: '今すぐリセット',
  ResetDialogTitle: '提出プロセスをリセットする',
  ResetDialogContent:
    '送信プロセスをリセットしてもよろしいですか?締切日時がリセットされます。',
  Confirm: '確認する',
  Region: '地域',
  KiraSuccessfullyConnectedTitle: 'キラとの接続に成功しました',
  KiraSuccessfullyConnectedFirstLine:
    'キラに書類を送って明らかにできるようになりました',
  KiraSuccessfullyConnectedSecondLine: '契約書や関連文書からの関連情報。',
  KiraProjectsLoading: 'プロジェクトを読み込み中...',
  KiraSelectProject: 'Kira でプロジェクトを選択してください...',
  KiraSendDocument: 'キラに書類を送る',
  KiraConnect: 'キラとつながる',
  KiraCompanyUrl: 'キラの会社の URL',
  KiraApiToken: 'キラAPIトークン',
  KiraUnableToConnect:
    'キラに接続できませんでした。リージョンとトークンを確認して、再試行してください。',
  KiraConfigError:
    '設定の読み込み中に問題が発生しました。もう一度試してください。',
  KiraProjectsLoadError:
    'Kira からプロジェクトを取得できませんでした。もう一度試してください。',
  KiraSendDocumentError:
    '文書をキラに送信する際に問題が発生しました。もう一度試してください。',
  KiraSendingDocument: '「${documentName}」を Kira に送信します',
  KiraDocumentSent: '「${documentName}」がキラに送信されました',
  Redact: '編集',
  RedactDocuments: '文書を編集する',
  EditRedact: '編集の編集',
  RedactionIsNotAvailable: '編集は利用できません',
  RedactGetDocumentError:
    'この文書を入手できませんでした。もう一度試してください',
  RedactBurnDocumentError:
    'この文書を編集できませんでした。もう一度試してください',
  RedactFileTooLarge:
    '${fileSize} より大きいファイルは、現時点ではリダクションでサポートされていません。ドキュメントのサイズを最適化して、再試行してください。',
  RedactSaveDialogTitle: '新しい編集済みドキュメントとして保存',
  MultipleDocumentsErrorDescription:
    '${numberOfDocuments} マークされたドキュメントを処理できませんでした。ドキュメントを再度アップロードしてみてください。',
  SingleDocumentErrorDescription:
    'マークされた 1 つのドキュメントは処理できませんでした。ドキュメントを再度アップロードしてみてください。',
  MultipleDocumentsInProgressDescription:
    '${numberOfDocuments} マークされたドキュメントの処理が完了していません。',
  SingleDocumentInProgressDescription:
    'マークされた 1 つのドキュメントの処理が完了していません。',
  CancelBulkRedaction: '一括編集をキャンセルする',
  CancelBulkRedactionMessage: `You are about to stop the redaction process.
  Stopping redaction will cease redaction on current document and return you to the document index.`,
  StopRedaction: '編集を停止する',
  DocumentLocation: '文書の場所',
  SecurityControls: 'セキュリティ管理',
  SecuritySettings: 'セキュリティ設定',
  UseFolderSecurityFrom: 'フォルダーのセキュリティ設定を使用する',
  UseSecurityFromOpenedDocument:
    '開いたドキュメントのセキュリティ設定を使用する',
  UseSecurityFromOriginalDocument:
    '元のドキュメントのセキュリティ設定を使用する',
  UseSecurityFromOriginalFolder: '元のフォルダーのセキュリティ設定を使用する',
  UseSecurityFromOriginalFoldersAndDocuments:
    '元のフォルダーと元のドキュメントのセキュリティ設定を使用する',
  DocumentWillBeDisabledByDefault:
    'ドキュメントはデフォルトでは無効になります。',
  DocumentsAndFoldersWillBeDisabledByDefault:
    'フォルダーとドキュメントはデフォルトでは無効になっています。',
  ImportDataRoomError:
    'trackingId ${trackingId} を使用したインポートはエラーです。もう一度試してください。',
  RedactionError:
    '${fileName} を編集できませんでした。もう一度お試しください。',
  RedactionHowRedactionSavingWorks: '墨消し保存の仕組み',
  RedactionEducationDialogForAdministrators: '管理者向け',
  RedactionEducationDialogForGuests: 'ゲスト向け',
  RedactionEducationDialogPreviewDownload: 'プレビュー/ダウンロード',
  RedactionEducationDialogEditing: '編集',
  RedactionEducationDialog1Layer: '1層文書',
  RedactionEducationDialog2Layer: '2層文書',
  RedactionEducationDialogRedactionsAreBakedIn:
    'リダクションは焼き付けられています',
  RedactionEducationDialogRedactionsAreEditable: '墨消しは編集可能です',
  RedactionSaveAsNewDocument: '新しいドキュメントとして保存',
  RedactionHowSavingWorks: '保存の仕組み',
  ChangesYouMadedWillNotBeSaved: '加えた変更は保存されません。',
  IsRedacted: '編集されています。',
  DocumentsAddedFrom: '${dataroomName} からドキュメントが追加されました。',
  GoToFile: '書類を見せてください',
  GoToImportFolder: 'フォルダを見せて',
  Thanks: 'ありがとう',
  Validation_DuplicatedDocumentInFolder:
    'ドキュメント ${documentName} は既に ${folderName} に存在します',
  Validation_NameCannotBeEmpty: '名前を空にすることはできません。',
  Continue: '続く',
  RedactingMessage:
    '編集には時間がかかる場合があります。リフレッシュしないでください',
  Name: '名前',
  Number: '番号',
  LearnMore: 'もっと詳しく知る',
  BulkActionsNoItemsWillBeAffected:
    'この操作による影響を受けるアイテムはありません。',
  Saving: '保存',
  YouCanKeepWorking: '働き続けることができます。',
  Copy: 'コピー',
  CopyDocument: 'ドキュメントのコピー先',
  CopyFolder: 'フォルダーのコピー先',
  Import: '輸入',
  DataRooms: 'データルーム',
  Accept: '受け入れる',
  TermOfAccess: 'アクセス期間',
  TermOfAccessCheckbox: '規約を読み、理解し、同意します',
  ImportingDataFrom: '${dataroomName} からドキュメントを追加しています。',
  Refresh: 'リフレッシュ',
  ImportTo: 'インポート先',
  ImportError: 'インポートエラー。管理者に連絡してください。',
  Back: '戻る',
  LastAccessed: 'アクセス済み',
  NeverAccessed: 'アクセスされていない',
  Remaining: '残り',
  SubmissionWindowIsOpen: '提出窓口は開いています。',
  SubmissionWindowHasEnd:
    '投稿受付期間は終了しました。今アップロードするドキュメントは遅延としてマークされます。',
  FromYourComputer: 'コンピューターから',
  FromAnotherDataRoom: '別のデータルームから',
  FromFolderStructure: 'フォルダー構造から',
  FromDataRoom: 'データルームより',
  AddFromDataRoom: 'データルームから追加',
  AddFromFolderStructure: 'フォルダー構造から追加',
  ImportDialogDataRoomScreenDialogTitle:
    'データ ルームからドキュメントを追加する',
  ImportDialogDataRoomScreenHeading:
    '追加するドキュメントが含まれるデータ ルームを選択します。',
  ImportDialogTermOfAccessScreenDialogTitle:
    '${dataroomName} からドキュメントを追加します',
  ImportDialogTermOfAccessScreenHeading:
    'このデータ ルームからドキュメントを追加するには、アクセス条件に同意する必要があります。',
  ImportDialogDataRoomScreenRadioBtn:
    'このデータ ルームからドキュメントを追加します',
  ImportDialogDocumentListScreenHeading:
    'データ ルームに追加するドキュメントを 1 つ以上選択します。',
  ImportDialogEmptyDataRoom: 'アクセスできるデータ ルームはありません。',
  ImportDialogEmptyDocument:
    'このデータ ルームから追加するドキュメントはありません。',
  ImportDialogDocumentListScreenDialogTitle:
    '${dataroomName} からドキュメントを追加します',
  UserTypeCode_ADM: '管理者',
  UserTypeCode_DOP: '出版社',
  UserTypeCode_GUE: 'ゲスト',
  UserTypeCode_USQ: '限定ビューア',
  UserTypeCode_USR: 'ビューア',
  QnaRoleCode_QVW: '質問ビューア',
  QnaRoleCode_BAP: '入札者承認者',
  QnaRoleCode_BAA: '入札者著者',
  QnaRoleCode_BMC: '入札者の主な連絡先',
  QnaRoleCode_IAP: '内部承認者',
  QnaRoleCode_IAA: '内部著者',
  QnaRoleCode_IMC: '内部主接点',
  QnaRoleCode_IOB: '内部オブザーバー',
  QnaRoleCode_QAU: '質問の作成者',
  QnaRoleCode_QAP: '質問承認者',
  QnaRoleCode_ADR: '回答起草者',
  QnaRoleCode_AAU: '回答者',
  QnaRoleCode_AAP: '回答承認者',
  QnaRoleCode_QAA: 'Q&amp;A管理者',
  QnaRoleCode_QAO: 'Q&amp;A オブザーバー フル コントロール',
  QnaRoleCode_QOV: 'Q&amp;A オブザーバー表示のみ',
  DemoRoom: '*デモ* - ${データルーム名}',
  SearchDocuments_InputPlaceholder:
    'キーワード、または文書またはフォルダーの名前と番号を入力します',
  SearchDocuments_Find: '探す',
  SearchDocuments_Results: '結果',
  SearchDocuments_FullTextSearchSummary:
    '${totalItems} document${plural} はコンテンツと一致します',
  SearchDocuments_DocumentSummary:
    '${totalItems} document${plural} はタイトル、番号、コードと一致します',
  SearchDocuments_FolderSummary:
    '${totalItems} フォルダー${plural} はタイトル、番号、コードと一致します',
  New: '新しい',
  Browse: 'ブラウズ',
  ImportFolder_GlobalActionButton: 'インポートフォルダー構造',
  ImportFolder_Title: 'フォルダー構造をインポートする',
  ImportFolder_Step1_DragDropDescription1:
    'Excel ファイルをドラッグ アンド ドロップするか参照してフォルダーをインポートします。',
  ImportFolder_Step1_DragDropDescription2:
    '注: フォルダーはインポート時に無効になります。',
  ImportFolder_Step1_DragDropDescription3:
    'Excel ファイルを、フォルダー番号を列 A、フォルダー名を列 B としてフォーマットするか、単に {0} としてフォーマットします。',
  ImportFolder_Step1_FileUploaded: '{0} がアップロードされました',
  ImportFolder_Step1_DownloadTemplateFile: 'エクセルテンプレートをダウンロード',
  ImportFolder_Step1_Heading: 'フォルダー構造を {0} にインポートしています',
  ImportFolder_Step1_ErrorMessage:
    'ファイルはアップロードされませんでした。 .xls または .xlsx ファイルを使用して再試行してください。',
  ImportFolder_Step2_Title: 'インポートを確認して完了します',
  ImportFolder_Step2_SuccessMessage: 'フォルダーがインポートされました。',
  Document_Preview: 'ドキュメントのプレビュー',
  FileUnsupportedForPreview: `We can’t show you a preview of this file.
    You’ll need to download the file to view the contents.`,
  ErrorWhileDownloadingFile:
    'ダウンロード中にエラーが発生しました。${ErrorCode} を使用してカスタマー サポートにお問い合わせください。',
  CannotDownloadingFile: 'ファイルをダウンロードできません。 ',
  ClickToSeeDetails: 'クリックして詳細を表示',
  TryAgain: 'もう一度やり直してください',
  NumberingUpdatedFor: '番号付けが更新されました',
  Items: 'アイテム',
  YoureAboutToChangeTheNumberingOn: '番号付けを変更しようとしています',
  ThisMayHaveAnImpactOnPeopleReferencingTheDocumentOnThisProject:
    'これは、このプロジェクトのドキュメントを参照する人々に影響を与える可能性があります。',
  AllDocuments: 'すべての文書',
  AllQnaAndAttachments: 'すべての Q&amp;A と添付ファイル',
  AllSubmissionDocuments: 'すべての提出書類',
  AllEvaluationAttachments: 'すべての評価添付ファイル',
  AllUserActivityDocumentViewsReports:
    '個人およびドキュメントビューごとのすべてのアクティビティログレポート',
  IncludeDocuments: 'ドキュメントを含める',
  IncludeSubmissionDocuments: '提出書類を含める',
  IncludeEvaluationAttachments: '評価添付ファイルを含める',
  IncludeQna: 'Q&amp;Aを含める',
  IncludeQnaAttachments: 'Q&amp;A の添付ファイルを含める',
  IncludeDisabledDocuments: '無効なドキュメントを含める',
  Documents: '書類',
  SubmissionDocuments: '提出書類',
  EvaluationAttachments: '評価添付ファイル',
  QnaAttachments: 'Q&amp;Aの添付ファイル',
  DisabledDocuments: '無効化された文書',
  DocumentsVisibleTo: '閲覧できるドキュメント',
  SubmissionDocumentsVisibleTo: '提出書類を閲覧できる人',
  QnaAndAttachmentsVisibleTo: 'Q&amp;A と添付ファイルを閲覧できるユーザー',
  QnaAttachmentsVisibleTo: 'Q&amp;A 添付ファイルを閲覧できるユーザー',
  QnaVisibleTo: 'Q&amp;A を閲覧できる人',
  IncludeDisabledDocumentsWarningMessage:
    '無効なドキュメントを含めると、選択したチームに現在表示されていないドキュメントが表示されます。このオプションは推奨されません。',
  AllSubTeams: 'すべてのサブチーム',
  AllSecurityGroups: 'すべてのセキュリティグループ',
  NoSubTeams: 'サブチームなし',
  AdminOnlyFullArchive: '管理者のみ - 完全なアーカイブ',
  Team: 'チーム',
  SubTeam: 'サブチーム',
  ArchiveName: 'アーカイブ名',
  Options: 'オプション',
  Summary: 'まとめ',
  CreateArchive: 'アーカイブの作成',
  IncludeInArchive: 'アーカイブに含める',
  VisibleTo: 'に見える',
  SubmissionDocuments_LowerCase: '提出書類',
  EvaluationAttachments_LowerCase: '評価添付ファイル',
  Qna: 'Q&amp;A',
  QnaAndAttachments_LowerCase: 'Q&amp;Aの添付ファイル',
  DisableDocuments_LowerCase: '無効化された文書',
  Questions_LowerCase: '質問',
  Attachments_LowerCase: '添付ファイル',
  DocumentViewsReports_LowerCase: 'ドキュメントビューレポート',
  ActivityLogsByPerson_LowerCase: '個人ごとの活動記録',
  InProgress: '進行中',
  Expired: '期限切れ',
  Failed: '失敗した',
  YourArchiveIsBeingGenerated: 'アーカイブが生成されています...',
  YourArchiveHasBeenQueued: 'アーカイブはキューに登録されました。',
  AnEmailWillBeSentTo: '電子メールが送信されます',
  WithADownloadLinkWhenTheArchiveIsReady:
    'アーカイブの準備ができたら、ダウンロード リンクを付けます。',
  ContactSupport: 'サポート問い合わせ先',
  SomethingWentWrong: '何か問題が発生しました。',
  WeAreUnableToProcessYourArchiveRequest:
    'アーカイブリクエストを処理できません。',
  Retrieving: '取得中',
  FullArchiveAdminOnly: '完全なアーカイブ - 管理者のみ',
  Filtered: 'フィルタリング済み',
  CreateYourFirstArchive: '最初のアーカイブを作成します。',
  AutoTruncateHelpText:
    'ファイル パスが 260 文字を超えないように、最適な切り詰めが適用されます。',
  Becomes_LowerCase: 'になる',
  TruncationType: 'トランケーションタイプ',
  AutoTruncate: '自動切り詰め',
  DoNotTruncate: '切り捨てないでください',
  KeepLastSegmentOfNumbers: '数値の最後のセグメントを保持する',
  KeepNumbersOnly: '数字だけを残しておく',
  KeepNamesOnly: '名前だけを残しておく',
  FullArchiveHelpText:
    'データ ルーム管理者は、すべてのドキュメントと Q&amp;A 添付ファイルを表示できます。',
  ArchiveHelpText:
    '${teamOrSubTeamName} に表示される ${includeOptions} を組み込みます。',
  HowArchivesWork: 'アーカイブの仕組み',
  ArchivesContainTheFullFilePathForEveryArchivedDocument:
    'アーカイブには、アーカイブされたすべてのドキュメントの完全なファイル パスが含まれます。',
  FilePathsAreLimitedTo260Characters:
    'ファイル パスは 260 文字に制限されています。',
  YouMayNeedToTruncateTheFilePaths:
    'コンピュータで表示できるように、ファイル パスを切り詰める必要がある場合があります。',
  YouCanUseAZipApplicationToViewArchivesWithLongFilePaths:
    'あるいは、ZIP アプリケーションを使用して、長いファイル パスを持つアーカイブを表示することもできます。',
  YourArchiveIsDownloading: 'アーカイブをダウンロード中です。',
  DoNotTruncateHelpText:
    'ZIP アプリケーションを使用して、長いファイル パスを持つドキュメントを抽出できます。',
  Share: '共有',
  SecureShare_Capitalize: 'セキュアシェア',
  SecureShare_SentenceCase: 'セキュアシェア',
  ValidateEmailToView: '表示する電子メールを検証する',
  ValidateEmailToViewDescription:
    'ドキュメントを表示する前に、電子メール アドレスを検証する必要があります。',
  EnterPasscodeToView: '閲覧するにはパスコードを入力してください',
  EnterPasscodeToViewDescription:
    'ユーザーがドキュメントを表示する前に入力するパスコードを設定します。',
  AnyoneWithALinkCanView: 'リンクを知っている人は誰でも閲覧できます',
  AnyoneWithALinkCanViewDescription:
    'リンクを知っている人は、ドキュメントに安全にアクセスできなくなります。',
  NoAccess: 'アクセスなし',
  NoAccessDescription:
    '共有リンクを持つユーザーはドキュメントを表示できなくなります。',
  SecureShareLinkSettings: '共有リンクへのアクセスを制御する',
  Watermark: '透かし',
  LinkExpiresIn: 'リンクは ${duration} (${timezone}) で期限切れになります',
  LinkExpiredDuration:
    'リンクの有効期限が切れています ${duration} 前 (${timezone})',
  LinkExpirationDate: 'リンクを期限切れにする日時を設定します',
  On: 'の上',
  Off: 'オフ',
  CreateWatermark: '透かしを作成する',
  None: 'なし',
  YouAreReadyToShare: '共有する準備ができました',
  WeHaveCopiedTheSecureShareLinkToYourClipboard:
    '<strong data-ansarada-ccd="true">${fileName}</strong>の安全なリンクをクリップボードにコピーしました。',
  AnyoneWithTheLinkCanviewTheDocument:
    'リンクを知っている人は誰でもドキュメントを閲覧できます。',
  PeopleNeedToValidateTheirEmailToViewTheDocument:
    'ドキュメントを表示するには電子メールを認証する必要があります。',
  PeopleNeedToEnterThePasscodeToViewTheDocument:
    'ドキュメントを表示するには、パスコード ( <strong data-ansarada-ccd="true">${passCode}</strong> ) を入力する必要があります。',
  SecureShareLink: '安全な共有リンク',
  SecureShareLinkCopy: 'コピーして共有できる安全なリンク',
  SaveAndRemoveAccess_SentenceCase: 'アクセス権の保存と削除',
  AccessPasscode: 'リンクにアクセスするにはパスコードを入力してください',
  SettingsSaved: '保存された設定',
  WeHaveExpiredAllSecureShareLinks:
    '<strong data-ansarada-ccd="true">${fileName}</strong>のすべての Secure Share リンクの有効期限が切れました。',
  LinkShareWithCode: 'コード付きのリンク共有',
  LinkShareWithEmail: 'リンクをメールで共有',
  LinkShare: 'リンクシェア',
  AllDownloadedCopiesWillSelfDestruct:
    'ダウンロードされたコピーはすべて自己破壊されます。',
  NeedHelpSharingALinkOrDocument:
    'リンクやドキュメントの共有についてサポートが必要ですか?',
  HowDoIExpireAllLinksToADocument:
    'ドキュメントへのすべてのリンクを期限切れにするにはどうすればよいですか?',
  WhatDoIDoToDenyADownload: 'ダウンロードを拒否するにはどうすればよいですか?',
  FindOutMoreAboutSecureShare:
    'ドキュメントを安全に共有する方法について詳しくは、こちらをご覧ください。',
  SaveAndCopyLink_SentenceCase: 'リンクを保存してコピーする',
  ShareDocumentSecurely_SentenceCase: 'ドキュメントを安全に共有する',
  ShareDocumentEmptyStateDescription:
    '共有を開始するには、「ドキュメントの管理」列からドキュメントを選択します。',
  FirstTellUsWhoYouAre: 'まず、あなたが誰なのか教えてください',
  ToAccessTheSharedDocumentWeNeedToVerifyYourEmailAddress:
    '共有ドキュメントにアクセスするには、電子メール アドレスを確認する必要があります。',
  WeWillSendYouAnEmailSoYouCanAccessTheSharedDocument:
    '共有ドキュメントにアクセスできるように電子メールを送信します。',
  EnterAnEmailAddress: 'メールアドレスを入力',
  EnterAValidEmailAddress: '有効なメールアドレスを入力してください',
  EmailIsRequired: 'メールアドレスは必須です',
  VerifyMyEmail_SentenceCase: 'メールアドレスを確認してください',
  FirstEnterThePasscode: 'まずパスコードを入力します',
  ToAccessTheSharedDocumentYouNeedToEnterThePasscode:
    '共有ドキュメントにアクセスするには、パスコードを入力する必要があります。',
  ReachOutToThePersonWhoSharedDocumentYouNeedToEnterThePasscode:
    '詳細については、リンクを共有した人に問い合わせてください。',
  EnterTheAccessPasscode: 'アクセスパスコードを入力してください',
  ViewDocument_SentenceCase: '文書を表示する',
  TheDocumentIsNoLongerAvailable: 'このドキュメントはもう入手できません',
  YourAccessMayHaveBeenRemovedOrTheDocumentDeleted:
    'アクセス権が削除されたか、ドキュメントが削除された可能性があります。',
  ReachOutToThePersonWhoSharedTheLinkWithYouToFindOutMore:
    '詳細については、リンクを共有した人に問い合わせてください。',
  SecurityControlsOn: 'セキュリティ制御がオンになっています',
  SecurityControlsOff: 'セキュリティ制御がオフになっている',
  CopyingAllowed: 'コピー許可',
  CopyingDenied: 'コピーが拒否されました',
  EditingAllowed: '編集許可',
  EditingDenied: '編集が拒否されました',
  DenyCopyingDisabled: 'コピー拒否が無効になっています',
  DenyEditingDisabled: '編集の拒否が無効になっています',
  DenyPrintingDisabled: '印刷拒否が無効になっています',
  DenySavingDisabled: '保存の拒否が無効になっています',
  Redirecting: 'リダイレクト中...',
  CheckYourInbox: 'メールチェックしてみて',
  YouAreOnADifferentDevice: '別のデバイスを使用しています',
  YouCanOnlyViewThisDocumentFromTheSameDeviceUsedToVerifyYourEmail:
    'このドキュメントは、電子メールの確認に使用したのと同じデバイスからのみ表示できます。',
  WeHaveSentAnEmailToYourEmail: 'にメールを送信しました ',
  WithTheAccessToViewTheDocument:
    ' ドキュメントを表示するためのアクセス権が付与されます。',
  ViewActivity: 'アクティビティの表示',
  PasscodeIsNotCorrect: 'パスコードが正しくありません',
  SubmissionDocumentUploaded:
    '1 件のドキュメントが提出にアップロードされました。',
  SubmissionDocumentsUploaded:
    '${NumberOfDocuments} ドキュメントが送信にアップロードされました。',
  HowSubmissionsWork: '提出の仕組み',
  AllAddedDocumentsAreAutomaticallySubmitted:
    '追加されたすべてのドキュメントは自動的に送信されます。',
  YouHaveUntilTheCloseOfTheSubmissionWindowToMakeChanges:
    '変更は提出期間が終了するまでに行ってください。',
  UntilClose: '閉店まで',
  Ansarada: 'アンサラダ',
  BulkEditFileUpload: `または、洗練された Excel をここにドラッグ アンド ドロップします。私たちは'
  overview of the edits.`,
  BulkEditFileUploadAfterUploading:
    'または、ここに適切なファイルをドラッグ アンド ドロップして、シームレスに切り替えます。',
  BulkEditExcelReady: '要は、${name}!編集した Excel の準備はできましたか?',
  BeforeYourEdits: '編集の前に',
  AfterYourEdits: '編集後',
  DropFilesHereToAttach: 'ここにファイルをドロップして添付します',
  KickOffBy: 'キックオフ',
  DownloadingTheExcelVersion: 'Excel バージョンをダウンロードする',
  OfYourDocumentIndex: 'ドキュメントインデックスの。',
  BulkEditNextButtonGuide:
    '微調整したら、 <strong>「次へ」</strong>ボタンをタップしてアップロードし、実際の効率性を確認します。',
  BulkEditDownloadExcelFileHeading:
    'ワークフローを向上: ドキュメントの編集をシームレスに。',
  BulkEditAllSetHeading:
    '準備完了です。${name}!あなたは行動を起こす準備ができています。',
  BulkEditButtonGuide:
    '<strong>一括編集</strong>ボタンをクリックすると、ディレクティブに従って ${combinedText} を微調整するように設定されます。',
  HeadsUpThough: `<strong>注意:</strong>少なくとも 1 つの編集は適用されません。管理者はそれらを文書インデックスから削除しました。`,
  ProTip: 'プロのヒント？',
  ProTipDescription:
    'ドキュメント インデックスの最新の Excel バージョンをダウンロードすることを検討してください。編集が開始される前に、元の状態のスナップショットが得られます。',
  GrabItHere: 'ここでそれをつかんでください。',
  BulkEditSuccessMessage: `一括更新が適用され、ドキュメント インデックスに追加されました。私たちはあなたをサポートします!`,
  NotTheRightExcel: '適切な Excel ではありませんか?',
  UploadFailedMessage:
    'アップロードに失敗しました。${name}。アップロード中に問題が発生しました。もう一度試してください。',
  FailedMessage:
    '更新に失敗しました。${name}。一括更新で問題が発生しました。もう一度試してください。',
  DoNotHaveAccessMessage:
    '提供された Excel で変更されたドキュメントとフォルダーの一部にアクセスできません。データ ルーム管理者に操作の実行を依頼してください。',
};
